import { serviceHelper } from '../utils/serviceHelper'

export const createPet = async (payload) => {
  const petApi = getAxiosCreate()
  const data = await petApi.post('/pets', payload)
  return data
}

export const updatePet = async ({ id, payload }) => {
  const petApi = getAxiosCreate()
  const data = await petApi.put(`/pets/${id}`, payload)
  return data
}

export const getBreeds = async (type) => {
  const petApi = getAxiosCreate()
  const { data } = await petApi.get(`/breeds/type/${type}`)
  return data
}
export const getPetsWithFilter = async ({ name, breedId, gender, breedType, skip, limit = 8 }) => {
  const petApi = getAxiosCreate()
  const queryParams = Object.entries({ name, breedId, gender, breedType, skip, limit })
    .filter(([_, value]) => value !== undefined)
    .map(([key, value]) => `${key}=${value}`)
    .join('&')

  const { data } = await petApi.get(`/pets/find/?${queryParams}`)
  return data
}

export const getPetById = async (id) => {
  const petApi = getAxiosCreate()
  const { data } = await petApi.get(`/pets/${id}`)
  return data
}

export const getPetByTutorId = async ({ tutorId, skip, limit = 8 }) => {
  const petApi = getAxiosCreate()
  const { data } = await petApi.get('/pets/find',
    { params: { ownerId: tutorId, skip, limit } })
  return data
}

const getAxiosCreate = () => {
  return serviceHelper.createApiClient(`${process.env.REACT_APP_PET_URL}`)
}
